//@ts-ignore

"use client";

import { useState } from "react";
import { validateForm, submitFormData } from "../Utils/formUtils";

const DemoForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    labName: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm(formData);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      setTimeout(() => setErrors({}), 3000);
      return;
    }

    try {
      await submitFormData(formData);

      setSubmitted(true);

      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
        labName: "",
      });

      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error("Submission Error:", error);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      {/* Heading */}
      <div>
        <h2 className="text-3xl md:text-4xl text-black font-bold leading-tight">
          Transform your lab with
          <span className="block text-black">Carer Pathology software!</span>
        </h2>

        <p className="text-gray-600 mt-3 text-sm md:text-base">
          Start Your 5-Day Free Trial of Our Pathology Lab Software Today —
          just enter your name and phone number below!
        </p>
      </div>

      {/* FORM */}
      <form
        //onSubmit={handleSubmit}
        className="flex flex-col gap-4 w-full md:w-[70%] text-gray-500"
      >
        {/* Name */}
        <div className="flex flex-col text-gray-500" >
          <input
            type="text"
            placeholder="Name"
            name="name"
            className={`border rounded-md px-3 py-2 bg-white ${
              errors.name ? "border-red-400" : "border-gray-300"
            }`}
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
          )}
        </div>

        {/* Phone Number */}
        <div className="flex flex-col">
          <div className="flex gap-3">
            <select className="border border-gray-300 rounded-md px-3 py-2 w-24 text-gray-500">
              <option value="+91">+91</option>
            </select>

            <input
              type="text"
              placeholder="Phone Number"
              name="phoneNumber"
              className={`border rounded-md px-3 py-2 bg-white w-full ${
                errors.phoneNumber ? "border-red-400" : "border-gray-300"
              }`}
              value={formData.phoneNumber}
              onChange={handleChange}
            />
          </div>
          {errors.phoneNumber && (
            <p className="text-red-500 text-sm mt-1">{errors.phoneNumber}</p>
          )}
        </div>

        {/* Email */}
        <div className="flex flex-col text-gray-500">
          <input
            type="email"
            placeholder="Email Id"
            name="email"
            className={`border rounded-md px-3 py-2 bg-white ${
              errors.email ? "border-red-400" : "border-gray-300"
            }`}
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
          )}
        </div>

        {/* Lab Name */}
        <div className="flex flex-col text-gray-500">
          <input
            type="text"
            placeholder="Lab Name"
            name="labName"
            className={`border rounded-md px-3 py-2 bg-white ${
              errors.labName ? "border-red-400" : "border-gray-300"
            }`}
            value={formData.labName}
            onChange={handleChange}
          />
          {errors.labName && (
            <p className="text-red-500 text-sm mt-1">{errors.labName}</p>
          )}
        </div>

        {/* Submit Button */}
        <div className="flex items-start gap-4 mt-2">
          <button
            type="submit"
            className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded-md transition"
          >
            GET A DEMO <span className="ml-2">→</span>
          </button>

          {submitted && (
            <p className="text-blue-600 text-base mt-2">
              We will get back to you soon...
            </p>
          )}
        </div>
      </form>
    </div>
  );
};

export default DemoForm;
